import { CaseOverview } from '@/features/case-overview/CaseOverview'
import { useCaseContext } from '../CaseContext'

export default function OverviewPage() {
  const { caseId } = useCaseContext()
  return (
    <div className="min-h-0 flex-1 overflow-y-auto bg-background p-4 md:p-6">
      <CaseOverview caseId={caseId} />
    </div>
  )
}
